import * as React from "react"
import { SVGProps } from "react"

const LinkedInIconLettersOnly = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 182 182" {...props}>
    <g fill="#FFF" fillRule="nonzero">
      <path d="M183.184 182.884h-37.931V123.48c0-14.166-.253-32.4-19.728-32.4-19.756 0-22.779 15.433-22.779 31.368v60.43H64.815V60.724h36.414v16.694h.51a39.907 39.907 0 0 1 35.928-19.733c38.444 0 45.533 25.288 45.533 58.186l-.016 67.014ZM0 22.016C-.002 9.86 9.851.002 22.008 0c12.157-.002 22.014 9.851 22.016 22.008a22.013 22.013 0 0 1-22.008 22.017C9.859 44.027.002 34.174 0 22.016ZM40.981 182.884H3.011V60.723h37.97z" />
    </g>
  </svg>
)
export default LinkedInIconLettersOnly
